import fecha from 'fecha';
window.fecha = fecha;
import * as Helper from '../helpers/helper';
import {destroyAccordions, setupAccordions} from "../helpers/accordions";

export default class Filter {
    constructor() {
        if(document.getElementsByClassName('search-page')[0])
            this.initEvents();
    }

    initEvents() {
        this.datepicker = null;
        this.dateInput = document.getElementById('date-input');
        this.dateFilter = document.getElementById('date-filter');
        this.makeDatePicker();
        this.makeFiltersResponsive();

        this.body = document.querySelector("body");
        const resizeObserver = new ResizeObserver(e => {
            const isMobile = window.matchMedia("(max-width: 800px)").matches;
            this.datepicker.options.autoApply = !isMobile;
            if (isMobile) {
                this.datepicker.options.grid = 1;
                this.datepicker.options.calendars = 1;
            } else {
                this.datepicker.options.grid = 2;
                this.datepicker.options.calendars = 2;
            }
        });
        resizeObserver.observe(this.body);
    }

    /**
     * Display responsive version
     */
    makeFiltersResponsive() {
        let filters_button = document.createElement('button');

        filters_button.classList.add('button','btn-sm','secondary');
        filters_button.id = 'filters_button';
        let icon = document.createElement('i');
        icon.classList.add('icon','icon-filters');

        filters_button.append(icon);
        document.querySelector('#header-nav .menu-container').append(filters_button);

        let filters_container = document.querySelector('.search-filters');
        let search_section = document.querySelector('.search-page');

        let eventList = document.querySelector('.event-list');
        let map_container = document.querySelector('.map-container');

        // filter container
        let date_modal = document.querySelector('.easepick-wrapper');

        filters_button.addEventListener('click', () => {
            if(map_container.classList.contains('open')) {
                document.querySelector('#data-wrapper').style.display = '';
            }
            //close map if open
            map_container.classList.remove('open');
            eventList.classList.remove('smallEventWrapper');

            search_section.classList.add('fullscreen-filters');
            filters_container.classList.add('open');
            setupAccordions();
        });

        let close_button = document.querySelector('.close-filter');
        close_button.addEventListener('click', () => {
            if(map_container.classList.contains('open')) {
                document.querySelector('#data-wrapper').style.display = '';
            }
            map_container.classList.remove('open');
            eventList.classList.remove('smallEventWrapper');

            search_section.classList.remove('fullscreen-filters');
            filters_container.classList.remove('open');

            const selects = document.querySelectorAll('.custom-select-wrapper > .custom-select');
            selects.forEach((select) => {
                select.classList.remove('open');
            });

            destroyAccordions();
        });

        let save_button = document.querySelector('#save-filters');
        save_button.addEventListener('click', (e) => {
            e.preventDefault();
            close_button.click();
        });

        this.dateFilter.addEventListener('click', event => {
            date_modal.style.height = '';
            if(!date_modal.classList.contains('datepicker--open')) {
                date_modal.classList.replace('datepicker--closed','datepicker--open');
                date_modal.style.height = '100%';
            }
        });
    }

    /**
     * On search page, make datepicker component
     */
    makeDatePicker() {
        if(document.getElementsByClassName('date-input')[0]) {
            this.datepicker = Helper.getDatePicker();

            const url = new URL(window.location.href);
            const split = url.searchParams.get("dates")?.split(' ⟶ ');
            if (split) {
                this.datepicker.setDateRange(split[0], split[1]);
            }

            // clear date input
            document.getElementById('reset-filters-button').addEventListener('click', () => {
                this.datepicker.clear();
                document.getElementById('reset-filters-button').style.display = 'none';
                this.dateInput.placeholder = window.jsTranslations['Dates'];
                this.dateInput.value = null;
            });
        }
    }
}
